import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { SidePanelState } from './types';

const initialState: SidePanelState = {
	isOpenPanel: true,
	isOpenParkingPanel: false,
};

const slice = createSlice({
	name: 'sidePanel',
	initialState,
	reducers: {
		setIsOpenPanel: (state, action: PayloadAction<boolean>) => {
			state.isOpenPanel = action.payload;
		},
		setIsOpenParkingPanel: (state, action: PayloadAction<boolean>) => {
			state.isOpenParkingPanel = action.payload;
		},
	},
});

export const { setIsOpenPanel, setIsOpenParkingPanel } = slice.actions;

export const sidePanelReducer = slice.reducer;
